module.exports = __webpack_public_path__ + "media/images/baslow1-bb35671f457e973af817327966fa48df.jpg";